'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z' });

var PictureInPicture = function PictureInPicture(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PictureInPicture = (0, _pure2.default)(PictureInPicture);
PictureInPicture.muiName = 'SvgIcon';

exports.default = PictureInPicture;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PictureInPicture.js
// module id = 2718
// module chunks = 0